export default "__VITE_ASSET__CwKphmhc__"